import * as React from 'react';
import { NavLink } from 'react-router-dom';
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '../../../../web/components/Breadcrumb';
import { getSessionAdminAccountsUrl } from '../Accounts';

export function AccountDetailsBreadcrumb({ accountName }: { accountName: string }) {
	const latestAdminAccountsUrl = React.useMemo(getSessionAdminAccountsUrl, []);
	return (
		<Breadcrumb>
			<BreadcrumbList>
				<BreadcrumbItem>
					<BreadcrumbLink asChild>
						<NavLink to={latestAdminAccountsUrl}>Accounts</NavLink>
					</BreadcrumbLink>
				</BreadcrumbItem>
				<BreadcrumbSeparator />
				<BreadcrumbItem>
					<BreadcrumbPage>{accountName}</BreadcrumbPage>
				</BreadcrumbItem>
			</BreadcrumbList>
		</Breadcrumb>
	);
}
